import * as React from "react";
import { useTranslation } from "react-i18next";

import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { Button, Checkbox, FormControlLabel, Grid, Typography } from "@mui/material";

import "./viewAllSubscriptions.css";

const ViewAllSubscriptions: React.FC<{}> = () => {
  const userSubscription = localStorage.getItem("userSubscriptionDetails");
  const userSubscriptionDetails = userSubscription
    ? JSON.parse(localStorage.getItem("userSubscriptionDetails") || "")
    : null;

  const { t } = useTranslation("translation");
  const [basicValue, setBasicValue] = React.useState<number>(0);
  const [basicPlusValue, setBasicPlusValue] = React.useState<number>(0);
  const [proValue, setProValue] = React.useState<number>(0);
  const [basic5Check, setBasic5Check] = React.useState<boolean>(false);
  const [basic10Check, setBasic10Check] = React.useState<boolean>(false);
  const [basicPlusCheck, setBasicPlusCheck] = React.useState<boolean>(false);
  const [proCheck, setProCheck] = React.useState<boolean>(false);

  const handleBasicChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setBasic10Check(e.target.checked);
    if (e.target.checked) {
      setBasicValue(1);
    } else {
      setBasicValue(0);
    }
    handleBasicReset();
  };

  const handleBasicReset = () => {
    setBasicPlusValue(0);
    setProValue(0);
    setBasicPlusCheck(false);
    setProCheck(false);
  };

  const handleBasicPlusChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setBasicPlusCheck(e.target.checked);
    if (e.target.checked) {
      setBasicPlusValue(1);
    } else {
      setBasicPlusValue(0);
    }
    handleBasicPlusReset();
  };

  const handleBasicPlusReset = () => {
    setBasicValue(0);
    setProValue(0);
    setBasic10Check(false);
    setProCheck(false);
    setBasic5Check(false);
  };

  const handleProChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setProCheck(e.target.checked);
    if (e.target.checked) {
      setProValue(1);
    } else {
      setProValue(0);
    }
    handleProReset();
  };

  const handleProReset = () => {
    setBasicValue(0);
    setBasicPlusValue(0);
    setBasic10Check(false);
    setBasicPlusCheck(false);
    setBasic5Check(false);
  };

  const handleBasicTotal = () => {
    let total: number = 25;
    if (basic10Check) total = total + 10 * basicValue;
    if (basic5Check) total = total + 5;
    return total;
  };

  const handleBasicPlusTotal = () => {
    let total: number = 40;
    if (basicPlusCheck) total = total + 10 * basicPlusValue;
    return total;
  };

  const handleProTotal = () => {
    let total: number = 50;
    if (proCheck) total = total + 10 * proValue;
    return total;
  };

  const basicPlusOrangeListingIndex = [2, 3, 4];
  const popularOrangeListingIndex = [5, 6];
  const premiumOrangeListingIndex = [7, 8];

  return (
    <>
      <Grid
        style={{
          display: "flex",
          justifyContent: "center",
          fontWeight: 900,
        }}
        className='p-4 flex flex-col items-center'
      >
        <Typography variant='h3'>{t("flexiblePlansHeading", "Flexible Plans")}</Typography>
        <Typography
          variant='h4'
          className='text-white p-2'
          style={{
            backgroundColor: "#074470",
            borderRadius: 20,
          }}
        >
          {t("changeYourSubscriptionHeading", "Change your subscription plan")}
        </Typography>
      </Grid>

      <Grid container mt={5} className='transparent-background h-auto'>
        <Grid item xs={2.5} className='current-plan-grid subscription-margin p-0'>
          {userSubscriptionDetails?.subscriptionId == 1 && (
            <Grid className='flex flex-row text-center justify-center items-center'>
              <CheckCircleIcon
                className={`landing-pricing-content-list-icon current-plan-checkbox flex flex-row`}
              />
              <Typography
                className={`landing-list-item-align landing-text-black-color font-semibold text-xl`}
              >
                {t(`currentPlan`, "Current Plan")}
              </Typography>
            </Grid>
          )}
        </Grid>

        <Grid item xs={3} className='current-plan-grid subscription-margin p-0'>
          {userSubscriptionDetails?.subscriptionId == 2 && (
            <Grid className='flex flex-row text-center justify-center items-center'>
              <CheckCircleIcon
                className={`landing-pricing-content-list-icon current-plan-checkbox flex flex-row`}
              />
              <Typography
                className={`landing-list-item-align landing-text-black-color font-semibold text-xl`}
              >
                {t(`currentPlan`, "Current Plan")}
              </Typography>
            </Grid>
          )}
        </Grid>

        <Grid item xs={3} className='current-plan-grid subscription-margin p-0'>
          {userSubscriptionDetails?.subscriptionId == 3 && (
            <Grid className='flex flex-row text-center justify-center items-center'>
              <CheckCircleIcon
                className={`landing-pricing-content-list-icon current-plan-checkbox flex flex-row`}
              />
              <Typography
                className={`landing-list-item-align landing-text-black-color font-semibold text-xl`}
              >
                {t(`currentPlan`, "Current Plan")}
              </Typography>
            </Grid>
          )}
        </Grid>

        <Grid item xs={3} className='current-plan-grid subscription-margin p-0'>
          {userSubscriptionDetails?.subscriptionId == 4 && (
            <Grid className='flex flex-row text-center justify-center items-center'>
              <CheckCircleIcon
                className={`landing-pricing-content-list-icon current-plan-checkbox flex flex-row`}
              />
              <Typography
                className={`landing-list-item-align landing-text-black-color font-semibold text-xl`}
              >
                {t(`currentPlan`, "Current Plan")}
              </Typography>
            </Grid>
          )}
        </Grid>
      </Grid>

      <Grid
        container
        mt={5}
        className='transparent-background'
        style={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Grid
          className='landing-pricing-grid subscription-background subscription-margin'
          item
          xs={2.5}
        >
          <Button className='landing-pricing-pro-out-popular' variant='contained'>
            {t("hide")}
          </Button>
          <Typography className='landing-secondary-color-subscription landing-pricing-heading'>
            {t("basic")}
          </Typography>
          <Typography className='landing-secondary-color-subscription landing-price-title'>
            <sup className='landing-price-super-script'>$</sup>25
            <sub className='landing-price-sub-script'>/mo.</sub>
          </Typography>
          <Typography className='landing-price-description'>{t("singleDisplay")}</Typography>
          {Array(2)
            .fill("")
            .map((element: string, index: number) => (
              <Grid key={index} display='flex' mt={2}>
                <CheckCircleIcon className='landing-pricing-content-list-icon landing-secondary-color-subscription' />
                <Typography className='landing-text-color landing-list-item-align'>
                  {t(`basicList${index + 1}`)}
                </Typography>
              </Grid>
            ))}
          <Grid display='flex' mt={2}>
            <CheckCircleIcon className='landing-pricing-content-list-icon landing-secondary-color-subscription' />
            <Typography className='landing-text-color landing-list-item-align'>
              {t("24/7Support")}
            </Typography>
          </Grid>
          {/* TODO: later - instead of margin top use flex property */}
          <Grid className='landing-pricing-extra-grid' mt='85%'>
            <FormControlLabel
              className='landing-pricing-checkbox'
              control={
                <Checkbox
                  checked={basic5Check}
                  onChange={() => {
                    handleBasicReset();
                    setBasic5Check(!basic5Check);
                  }}
                />
              }
              label={t("+$5")}
            />
            <Typography className='landing-pricing-checkbox'>{t("$5Description")}</Typography>
            <Grid display='flex' alignContent='space-between'>
              <FormControlLabel
                className='landing-pricing-checkbox'
                control={
                  <Checkbox
                    checked={basic10Check}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleBasicChange(e)}
                  />
                }
                label={t("+$10")}
              />
              {/* <AdsAddOn value={basicValue} setValue={setBasicValue} setCheck={setBasic10Check} handleReset={handleBasicReset}/> */}
            </Grid>
            <Typography className='landing-pricing-checkbox'>{t("$10Description")}</Typography>
            <Typography className='landing-secondary-color-subscription landing-pricing-total' align='center'>
              {t("total") + `$${handleBasicTotal()}.00`}
            </Typography>
          </Grid>
          {/* <Button className='landing-pricing-button-variant' variant='contained'>
            {t("buyNow")}
          </Button>
          <Button className='landing-pricing-button-outlined'>{t("free30DaysTrail$0")}</Button> */}
        </Grid>
        <Grid
          className='landing-pricing-grid subscription-background subscription-margin'
          item
          xs={3}
        >
          <Button className='landing-pricing-pro-out-popular' variant='contained'>
            {t("hide")}
          </Button>
          <Typography className='landing-secondary-color-subscription landing-pricing-heading'>
            {t("basicPlus")}
          </Typography>
          <Typography className='landing-secondary-color-subscription landing-price-title'>
            <sup className='landing-price-super-script'>$</sup>40
            <sub className='landing-price-sub-script'>/mo.</sub>
          </Typography>
          <Typography className='landing-price-description'>
            {t("singleDisplay/MultipleDisplay")}
          </Typography>
          {Array(5)
            .fill("")
            .map((element: string, index: number) => (
              <Grid key={index} display='flex' mt={2}>
                <CheckCircleIcon
                  className={`landing-pricing-content-list-icon landing-secondary-color-subscription ${
                    basicPlusOrangeListingIndex.includes(index) && "landing-orange-color"
                  }`}
                />
                <Typography
                  className={`landing-text-color landing-list-item-align ${
                    basicPlusOrangeListingIndex.includes(index) && "landing-text-orange-color"
                  }`}
                >
                  {t(`basicPlusList${index + 1}`)}
                </Typography>
              </Grid>
            ))}
          <Grid display='flex' mt={2}>
            <CheckCircleIcon className='landing-pricing-content-list-icon landing-secondary-color-subscription' />
            <Typography className='landing-text-color landing-list-item-align'>
              {t("24/7Support")}
            </Typography>
          </Grid>
          {/* TODO: later - instead of margin top use flex property */}
          <Grid className='landing-pricing-extra-grid' mt='63%'>
            <Grid display='flex' alignContent='space-between'>
              <FormControlLabel
                className='landing-pricing-checkbox'
                control={
                  <Checkbox
                    checked={basicPlusCheck}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleBasicPlusChange(e)}
                  />
                }
                label={t("+$10")}
              />
              {/* <AdsAddOn value={basicPlusValue} setValue={setBasicPlusValue} setCheck={setBasicPlusCheck} handleReset={handleBasicPlusReset}/> */}
            </Grid>
            <Typography className='landing-pricing-checkbox'>{t("$10Description")}</Typography>
            <Typography className='landing-secondary-color-subscription landing-pricing-total' align='center'>
              {t("total") + `$${handleBasicPlusTotal()}.00`}
            </Typography>
          </Grid>
          {/* <Button className='landing-pricing-button-variant' variant='contained'>
            {t("buyNow")}
          </Button>
          <Button className='landing-pricing-button-outlined'>{t("free30DaysTrail$0")}</Button> */}
        </Grid>
        <Grid
          className='landing-pro-pricing-grid landing-pricing-grid subscription-margin'
          item
          xs={3}
        >
          <Button
            className='landing-pricing-pro-popular popular-pricing-heading'
            variant='contained'
          >
            {t("popular")}
          </Button>
          <Typography className='landing-text-white-color landing-pricing-heading'>
            {t("pro")}
          </Typography>
          <Typography className='landing-text-white-color landing-price-title'>
            <sup className='landing-price-super-script'>$</sup>50
            <sub className='landing-price-sub-script landing-text-white'>/mo.</sub>
          </Typography>
          <Typography className='landing-price-description landing-text-white-color'>
            {t("singleDisplay/MultipleDisplay")}
          </Typography>
          {Array(8)
            .fill("")
            .map((element: string, index: number) => (
              <Grid key={index} display='flex' mt={2}>
                <CheckCircleIcon
                  className={`landing-pricing-content-list-icon ${
                    popularOrangeListingIndex.includes(index)
                      ? "landing-orange-color"
                      : "landing-text-white-color"
                  }`}
                />
                <Typography
                  className={`landing-list-item-align ${
                    popularOrangeListingIndex.includes(index)
                      ? "landing-text-orange-color"
                      : "landing-text-white-color"
                  }`}
                >
                  {t(`proList${index + 1}`)}
                </Typography>
              </Grid>
            ))}
          <Grid display='flex' mt={2}>
            <CheckCircleIcon className='landing-pricing-content-list-icon landing-text-white-color' />
            <Typography className='landing-text-white-color landing-list-item-align'>
              {t("24/7Support")}
            </Typography>
          </Grid>
          {/* TODO: later - instead of margin top use flex property */}
          <Grid className='landing-pricing-extra-grid' mt='16%'>
            <Grid display='flex' alignContent='space-between'>
              <FormControlLabel
                className='landing-text-white-color landing-pricing-checkbox'
                control={
                  <Checkbox
                    checked={proCheck}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleProChange(e)}
                    className='landing-text-white-color'
                  />
                }
                label={t("+$10")}
              />
              {/* <AdsAddOn proPack={true} value={proValue} setValue={setProValue} setCheck={setProCheck} handleReset={handleProReset}/> */}
            </Grid>
            <Typography className='landing-text-white-color landing-pricing-checkbox'>
              {t("$10Description")}
            </Typography>
            <Typography className='landing-text-white-color landing-pricing-total' align='center'>
              {t("total") + `$${handleProTotal()}.00`}
            </Typography>
          </Grid>
          {/* <Button className='landing-pricing-pro-button-variant' variant='contained'>
            {t("buyNow")}
          </Button>
          <Button className='landing-pricing-pro-button-outlined'>{t("free30DaysTrail$0")}</Button> */}
        </Grid>
        <Grid
          className='landing-pricing-grid subscription-background subscription-margin'
          item
          xs={3}
        >
          <Button className='landing-pricing-pro-out-popular' variant='contained'>
            {t("hide")}
          </Button>
          <Typography className='landing-secondary-color-subscription landing-pricing-heading'>
            {t("premium")}
          </Typography>
          <Typography className='landing-secondary-color-subscription landing-price-title'>
            <sup className='landing-price-super-script'>$</sup>75
            <sub className='landing-price-sub-script'>/mo.</sub>
          </Typography>
          <Typography className='landing-price-description'>
            {t("singleDisplay/MultipleDisplay")}
          </Typography>
          {Array(10)
            .fill("")
            .map((element: string, index: number) => (
              <Grid key={index} display='flex' mt={2}>
                <CheckCircleIcon
                  className={`landing-pricing-content-list-icon ${
                    premiumOrangeListingIndex.includes(index)
                      ? "landing-orange-color"
                      : "landing-secondary-color-subscription"
                  }`}
                />
                <Typography
                  className={`landing-text-color landing-list-item-align ${
                    premiumOrangeListingIndex.includes(index)
                      ? "landing-text-orange-color"
                      : "landing-text-color"
                  }`}
                >
                  {t(`premiumList${index + 1}`)}
                </Typography>
              </Grid>
            ))}
          <Grid display='flex' mt={2}>
            <CheckCircleIcon className='landing-pricing-content-list-icon landing-secondary-color-subscription' />
            <Typography className='landing-text-color landing-list-item-align'>
              {t("24/7Support")}
            </Typography>
          </Grid>
          <Grid className='landing-pricing-extra-grid' mt={3}>
            <Typography className='landing-secondary-color-subscription landing-pricing-total' align='center'>
              {t("total") + "$75.00"}
            </Typography>
          </Grid>
          {/* <Button className='landing-pricing-button-variant' variant='contained'>
            {t("buyNow")}
          </Button>
          <Button id='about-us' className='landing-pricing-button-outlined'>
            {t("free30DaysTrail$0")}
          </Button> */}
        </Grid>
      </Grid>
    </>
  );
};

export default ViewAllSubscriptions;
